<template>
  <div>
    <inertia-link :href="backTo" class="flex items-center text-white text-sm md:text-base mb-4">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-2" fill="none" viewBox="0 0 24 24"
           stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1"
              d="M11 15l-3-3m0 0l3-3m-3 3h8M3 12a9 9 0 1118 0 9 9 0 01-18 0z"/>
      </svg>
      <p v-if="backTo === route('home')">{{ $trans('app.test.back-to-home') }}</p>
      <!--<p v-else-if="backTo === route('survey.start', $page.props.survey.slug)">Retour au test</p>-->
      <p v-else>{{ $trans('app.test.back-to-results') }}</p>
    </inertia-link>
    <div class="md:flex justify-center">
      <div class="grid grid-cols-3 gap-2 md:gap-10 text-center">
        <div v-for="s in steps" class="flex flex-col items-center">
          <div
              class="flex items-center justify-center rounded-full w-6 md:w-8 h-6 md:h-8 font-bold text-base md:text-lg mb-2 text-medium-blue border md:border-2 border-medium-blue"
              :class="{active : currentStep == s.number}">
            {{ s.number }}
          </div>
          <p class="text-white text-xs md:text-base">{{ s.title }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    step: {},
    backTo: {
      default: route('home')
    }
  },
  data() {
    return {
      currentStep: this.step,
      steps: [
        {
          'title': 'Questionnaire',
          'number': 1
        },
        {
          'title': 'Choix de la formule',
          'number': 2
        },
        {
          'title': 'Résultats',
          'number': 3
        }
      ]
    }
  }
}
</script>

<style>
.active {
  @apply bg-white border-0;
}
</style>
